import Vue from "@src/libraries/vue";
import _window from "@src/libraries/window";
import { DOMContentLoaded, windowLoad, crawlersLoad, isType, parse } from '@src/assets/js/utils';
import { persistent } from "@src/assets/js/requests/storage";
import { moduleDebug } from "@src/assets/js/debug";
import localesStore from "@src/store/locales";
import { router } from "@src/plugins/router";
const indexStore = new Vue({
    name: "Store",
    data() {
        const data = {
            simple: _window.location && _window.location.host.includes("simple"),
            location: {
                city: null,
                district: null
            },
            drawerDialog: {
                model: false
            },
            dinersDialog: {
                model: false,
                persistent: false
            },
            recipesDialog: {
                model: false,
                weekRecipe: null,
                attach: undefined
            },
            dayMenuDialog: {
                model: false,
                indexDay: null,
                day: []
            },
            loginDialog: {
                model: false,
                reload: false,
                social: ""
            },
            feedbackDialog: {
                model: false
            },
            languageDialog: {
                locale: "",
                model: false
            },
            alerts: {
                favorite: { visible: false },
                planning: { visible: false },
                subscribeEmail: { visible: false },
            },
            homeMenuDialog: {
                model: false
            },
            recipeCarouselDialog: {
                model: false
            },
            tourDialog: {
                model: false
            },
            findingSupermarketsDialog: {
                model: false
            },
            loadingSupermarketCartDialog: {
                status: "",
                accept: null
            },
            introDialog: {
                model: false
            },
        };
        return data;
    },
    computed: {
        locale() {
            if (localesStore.locale)
                return localesStore.locale;
            if (router && router.currentRoute.params.locale)
                return router.currentRoute.params.locale;
            return "";
        },
        metaSufix() {
            return ` - ComoQuiero`;
        }
    },
    asyncComputed: {
        async DOMContentLoaded() {
            await DOMContentLoaded();
            console.log("DOMContentLoaded!!!");
            return true;
        },
        async windowLoad() {
            await windowLoad();
            return true;
        },
        async crawlersLoad() {
            if (!process.client)
                return;
            await crawlersLoad();
            console.log("crawlersLoad!!!");
            return true;
        },
        webpSupport: {
            async get() {
                return new Promise(resolve => {
                    if (!process.client)
                        return true;
                    const img = new Image();
                    img.onload = function () {
                        resolve(img.width > 0 && img.height > 0);
                    };
                    img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
                });
            },
            default() {
                const document = _window.document;
                if (!document)
                    return true;
                const elem = document.createElement('canvas');
                if (!!(elem.getContext && elem.getContext('2d'))) {
                    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
                }
                else {
                    return false;
                }
            }
        }
    },
    watch: {
        location: {
            handler(location) {
                persistent.setItem("location", JSON.stringify(location));
            },
            deep: true
        }
    },
    async created() {
        const locationJson = await persistent.getItem("location");
        const location = parse(locationJson);
        if (location)
            this.location = location;
    },
    methods: {
        getAsyncData(key, type) {
            var _a;
            const nuxtData = (_a = _window.__NUXT__) === null || _a === void 0 ? void 0 : _a.data;
            const asyncData = (nuxtData && nuxtData.length ? nuxtData[0] : null);
            const data = asyncData && asyncData[key];
            if (data && isType(data, type))
                return data;
        }
    }
});
export default indexStore;
moduleDebug(indexStore);
export function metaSufix(txt) {
    return txt + " - " + indexStore.metaSufix;
}
